import { Default } from './Default'
import { Group } from './Group'

const Option = {
  Default: Default,
  Group: Group,
}

export { Option }
